import React from "react";
import MainCard from "../components/MainCard";
import Testimonials from "../components/Testimonials";
import CourseBox from "../components/CourseBox";

const Home = () => {
	return (
		<div>
			<MainCard />
			<CourseBox title={"Recommended Courses"} />
			<Testimonials />
		</div>
	);
};

export default Home;
